import { render, staticRenderFns } from "./EntrypointEditList.vue?vue&type=template&id=2ff33726&scoped=true&"
import script from "./EntrypointEditList.vue?vue&type=script&lang=js&"
export * from "./EntrypointEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff33726",
  null
  
)

export default component.exports